import React, {
  useEffect, useMemo, useState, useCallback
} from 'react'
import PropTypes from 'prop-types'
import {
  Modal,
  Input,
  DatePicker,
  Select,
  Button,
  Form,
  Cascader
} from 'antd'
import moment from 'moment'
import 'moment/locale/zh-cn'
import styles from './index.scss'
import { submitPartnerInfo, getCityList } from '../../services'
import provinceConfig from './provinceConfig'

import CodeModal from '../CodeModal'

// 表单组件
const InfoForm = Form.create()(({
  form,
  phone,
  token,
  close,
  showSuccess
}) => {
  const [vertifyCode, setVertifyCode] = useState('') // 校验码
  const [codeImg, setCodeImg] = useState('') // 二维码图片
  const setImg = useCallback(img => setCodeImg(img), [setCodeImg]) // 设置二维码图片
  const setCode = useCallback( // 输入二维码
    (value) => {
      setVertifyCode(value)
    },
    [setVertifyCode]
  )
  const { getFieldDecorator, validateFields, resetFields } = form
  // const { getFieldDecorator, validateFields } = form
  // 表单样式
  const ItemProps = {
    labelCol: { span: 7 },
    wrapperCol: { span: 14 },
    colon: false,
    style: { height: '58px', marginBottom: '0px' },
    className: 'r-partner-add__form-item'
  }
  const [options, setOptions] = useState(provinceConfig) // 省份数据
  const [formData, setFormData] = useState({ // 表单数据
    remark: '',
    channel: undefined,
    shop: undefined,
    industry: undefined,
    address: '',
    recom_info: ''
  })
  const [formDataFlag, setFormDataFlag] = useState({
    name: false, // 姓名
    remark: false, // 备注
    channel: false, // 渠道
    shop: false, // 是否有商铺回调
    industry: false, // 是否汽车行业
    address: false, // 地址回调
    recom_info: false, // 推荐人回调
    join: false
  })

  const formFlagStr = useMemo(() => JSON.stringify(formDataFlag))
  // const formStr = useMemo(() => JSON.stringify(formData))
  useEffect(() => () => {
    global.$rbl.push({
      event: 'copartner-detailpage_information_input'
    })
  }, [formFlagStr])
  const remarkChange = (e) => { // 输入备注回调
    setFormData({
      ...formData,
      remark: e.target.value
    })
    if (!formDataFlag.remark) {
      setFormDataFlag({
        ...formDataFlag,
        remark: true
      })
    }
  }
  const channelChange = (value) => { // 选择渠道回调
    setFormData({
      ...formData,
      channel: value
    })
    if (!formDataFlag.channel) {
      setFormDataFlag({
        ...formDataFlag,
        channel: true
      })
    }
  }
  const shopChannge = (value) => { // 是否有商铺回调
    setFormData({
      ...formData,
      shop: value
    })
    if (!formDataFlag.shop) {
      setFormDataFlag({
        ...formDataFlag,
        shop: true
      })
    }
  }
  const industryChange = (value) => { // 是否汽车行业回调
    setFormData({
      ...formData,
      industry: value
    })
    if (!formDataFlag.industry) {
      setFormDataFlag({
        ...formDataFlag,
        industry: true
      })
    }
  }
  const addressChange = (e) => { // 地址回调
    setFormData({
      ...formData,
      address: e.target.value
    })
    if (!formDataFlag.address) {
      setFormDataFlag({
        ...formDataFlag,
        address: true
      })
    }
  }
  const recomInfoChange = (e) => { // 推荐人回调
    setFormData({
      ...formData,
      recom_info: e.target.value
    })
    if (!formDataFlag.recom_info) {
      setFormDataFlag({
        ...formDataFlag,
        recom_info: true
      })
    }
  }

  // 选择省份获取城市
  const loadCity = async (selectedOptions) => {
    const targetOption = selectedOptions[selectedOptions.length - 1]
    targetOption.loading = true

    const params = {
      province: targetOption.value
    }
    const { data: cityList } = await getCityList(params)
    targetOption.children = cityList.sort((a, b) => a.localeCompare(b, 'zh-CN')).map(city => ({ value: city, label: city }))
    targetOption.loading = false
    setOptions([...options])
  }

  const regionPopchange = (value) => {
    if (!value) {
      validateFields(['region'])
    }
  }

  // 提交表单信息
  const handleSubmit = () => {
    validateFields(async (err, values) => {
      if (!err) {
        global.$rbl.push({
          event: 'copartner-detailpage_information-submit_click'
        })
        const { name, region, join } = values
        let params = {}
        if (formData.remark) {
          params.remark = formData.remark
        }
        if (formData.channel) {
          params.channel = formData.channel
        }

        if (formData.shop === 1 || formData.shop === 0) {
          params.shop = formData.shop
        }

        if (formData.industry === 1 || formData.industry === 0) {
          params.industry = formData.industry
        }

        if (formData.address) {
          params.address = formData.address
        }

        params = {
          ...params,
          name,
          province: region[0],
          city: region[1],
          join: join.format('YYYY-MM-DD'),
          phone,
          token,
          intent_type: 'rrc-openapi-partner',
          device: '',
          origin: '',
          verify_code: vertifyCode
        }

        try {
          // setCodeImg(Math.random())
          await submitPartnerInfo(params)
          // 返回二维码图片，显示二维码输入弹窗CodeModal
          resetFields()
          setFormData({
            remark: '',
            channel: undefined,
            shop: undefined,
            industry: undefined,
            address: '',
            recom_info: ''
          })
          showSuccess && showSuccess()
          close && close()
        } catch (error) {
          const res = error.data
          if (res.status === 200) {
            if (res.msg.status === 400) {
              setCode('')
              setCodeImg(res.msg.image)
            }
          }
        }
      }
    })
  }
  // 省份城市校验函数
  const checkProvinceAndCity = (rule, value, callback) => {
    if (value.length === 0) {
      return callback('请选择省份和城市')
    }
    if (value.length === 1) {
      return callback('请选择城市')
    }
    return callback()
  }
  // 日期选择器，限制不能选今天以前 和 一年以后
  const disabledDate = current => (current <= moment().subtract(1, 'days') || current >= moment().add(1, 'years').subtract(1, 'days'))

  return (
    <>
      <Form>
        <Form.Item
          label="姓名"
          {...ItemProps}
        >
          {
          getFieldDecorator('name', { rules: [{ required: true, message: '请输入姓名' }] })(
            <Input
              size="large"
              maxLength={5}
              className="name"
              placeholder="请填写您的姓名称呼"
              onChange={() => {
                if (!formDataFlag.name) {
                  setFormDataFlag({
                    ...formDataFlag,
                    name: true
                  })
                }
              }}
              onBlur={() => {
                validateFields(['name'])
              }}
            />
          )
        }
        </Form.Item>
        <Form.Item
          label="计划开业地区"
          {...ItemProps}
        >
          {
          getFieldDecorator('region', {
            initialValue: [],
            rules: [{ required: true, validator: checkProvinceAndCity }]
          })(<Cascader
            size="large"
            placeholder="请选择计划开业地区"
            options={options}
            loadData={loadCity}
            onPopupVisibleChange={regionPopchange}
            onChange={() => {
              if (!formDataFlag.region) {
                setFormDataFlag({
                  ...formDataFlag,
                  region: true
                })
              }
            }}
          />)
        }
        </Form.Item>
        <Form.Item
          label="填写详细地址"
          {...ItemProps}
        >
          <Input className="address" maxLength={30} value={formData.address} onChange={addressChange} placeholder="请输入详细开业地址，街道，门牌号（选填）" size="large" />
        </Form.Item>
        <Form.Item
          label="最快加盟时间"
          {...ItemProps}
        >
          {
          getFieldDecorator('join', { rules: [{ required: true, message: '请选择最快加盟时间' }] })(
            <DatePicker
              className="date"
              size="large"
              placeholder="请选择最快加盟时间"
              showToday={false}
              format="YYYY-MM-DD"
              disabledDate={disabledDate}
              allowClear={false}
              onBlur={() => { validateFields(['join']) }}
              onChange={() => {
                if (!formDataFlag.join) {
                  setFormDataFlag({
                    ...formDataFlag,
                    join: true
                  })
                }
              }}
            />
          )
        }
        </Form.Item>
        <Form.Item
          label="是否从事过汽车相关行业"
          {...ItemProps}
        >
          <Select value={formData.industry} onChange={industryChange} placeholder="请选择" size="large">
            <Select.Option value={1}>是</Select.Option>
            <Select.Option value={0}>否</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item
          label="是否有汽车相关店铺"
          {...ItemProps}
        >
          <Select value={formData.shop} onChange={shopChannge} placeholder="请选择" size="large">
            <Select.Option value={1}>是</Select.Option>
            <Select.Option value={0}>否</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item
          label="了解人人车合伙人加盟渠道"
          {...ItemProps}
        >
          <Select value={formData.channel} onChange={channelChange} placeholder="请选择" size="large">
            <Select.Option value="他人推荐">他人推荐</Select.Option>
            <Select.Option value="广告宣传">广告宣传</Select.Option>
            <Select.Option value="人人车离职员工">人人车离职员工</Select.Option>
            <Select.Option value="平台活跃车商">平台活跃车商</Select.Option>
          </Select>
        </Form.Item>
        { formData.channel === '他人推荐'
        && (
        <Form.Item
          label="介绍人信息"
          {...ItemProps}
        >
          <Input className="recom-info" maxLength={20} value={formData.recom_info} onChange={recomInfoChange} placeholder="请填写介绍人手机号或姓名（选填）" size="large" />
        </Form.Item>
        ) }
        <Form.Item
          label="备注"
          {...{ ...ItemProps, style: { marginBottom: '15px' } }}
        >
          <Input.TextArea maxLength={300} style={{ fontSize: '14px' }} value={formData.remark} onChange={remarkChange} placeholder="请输入想咨询的问题和其他建议。（选填）" className="remark" rows={5} size="large" />
        </Form.Item>
        <Form.Item className="r-partner-add__button">
          <Button className="button" type="primary" size="large" onClick={handleSubmit}>提交</Button>
        </Form.Item>
      </Form>
      { codeImg && <CodeModal code={vertifyCode} img={codeImg} setImg={setImg} setVertifyCode={setCode} signUp={handleSubmit} /> }
    </>
  )
})

const InfoModal = ({
  token,
  close,
  phone,
  showSuccess
}) => (
  <>
    <Modal visible={!!token} width="730px" footer={null} onCancel={close} centered bodyStyle={{ paddingTop: '30px', paddingBottom: '30px' }}>
      <div
        className={styles['r-partner-add']}
        // data-exposure="合伙人招商补充信息页"
      >
        <header className="r-partner-add__header">
          <h2>合伙人登记表</h2>
          <h3>完善个人信息，以便为您定制最优加盟方案</h3>
        </header>
        <InfoForm phone={phone} token={token} close={close} showSuccess={showSuccess} />
      </div>
    </Modal>
  </>
)

InfoModal.propTypes = {
  token: PropTypes.string,
  phone: PropTypes.string,
  close: PropTypes.func,
  showSuccess: PropTypes.func
}

InfoModal.defaultProps = {
  token: '',
  phone: '',
  close: () => ({}),
  showSuccess: () => ({})
}

export default InfoModal
